/* eslint-disable camelcase */
(() => {
  angular
    .module('app')
    .controller(
      'host.views.employees.uncoveredTreatmentTreeModal',
      UncoveredTreatmentTreeModalController
    );

  UncoveredTreatmentTreeModalController.$inject = [
    '$uibModalInstance',
    'abp.services.app.hostEmployee',
    'employeeId',
    'serviceType',
    'serviceTypeName',
    '$rootScope',
  ];

  function UncoveredTreatmentTreeModalController(
    $uibModalInstance,
    hostEmployeeSvc,
    employeeId,
    serviceType,
    serviceTypeName,
    $root
  ) {
    const vm = this;
    const elementId = 'treatmentTree';
    vm.loading = 0;
    vm.serviceTypeName = serviceTypeName;

    vm.search = search;
    vm.cancel = cancel;
    init();

    function init() {
      getTreatments();
    }

    function getTreatments() {
      vm.loading += 1;
      hostEmployeeSvc
        .getTreatments({
          id: employeeId,
          serviceType,
        })
        .success((data) => {
          vm.treatments = data.items;
          vm.excludeTypicallyUncoveredSpecialistTreatments =
            data.excludeTypicallyUncoveredSpecialistTreatments;
          buildTreatmentTree();
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function buildTreatmentTree() {
      const element = $(`#${elementId}`);
      const ref = $.jstree.reference(element);
      if (ref) {
        ref.destroy();
      }

      const coveredNodeIcon = '<i class="fas fa-check text-navy"></i> ';
      const uncoveredNodeIcon = '<i class="fas fa-times text-danger"></i> ';
      function getNodeText(data) {
        return (data.isCovered ? coveredNodeIcon : uncoveredNodeIcon) + data.displayName;
      }

      const treatments = _.map(vm.treatments, (record) => ({
        id: record.id,
        parent: record.parentId ? record.parentId : '#',
        displayName: record.displayName,
        text: getNodeText(record),
        state: {
          opened: record.hasUncoveredChildren,
        },
        a_attr: {
          title: record.displayName,
        },
      }));

      // only show if is specialist.

      if (serviceType === 5) {
        const icon = vm.excludeTypicallyUncoveredSpecialistTreatments
          ? uncoveredNodeIcon
          : coveredNodeIcon;
        treatments.unshift({
          id: -1,
          parent: '#',
          text: `${icon}<strong>Typically uncovered specialist treatments</strong> <a>(View)</a>`,
          a_attr: {
            href: $root.resolveAppPath('Print/TypicallyUncoveredSpecialistTreatments'),
            title: 'Typically uncovered specialist treatments',
          },
        });
      }

      element
        .jstree({
          core: {
            data: treatments,
          },
          types: {
            default: {
              icon: 'fas fa-folder tree-item-icon-color icon-lg',
            },
            file: {
              icon: 'fas fa-file tree-item-icon-color icon-lg',
            },
          },
          search: {
            fuzzy: false,
            show_only_matches: true,
            show_only_matches_children: true,
          },
          sort(itemA, itemB) {
            const nodeA = this.get_node(itemA);
            const nodeB = this.get_node(itemB);
            if (nodeB.original.id === -1) {
              return 1;
            }
            if (nodeA.children_d.length > 0 && nodeB.children_d.length === 0) {
              return -1;
            }

            return nodeB.original.displayName < nodeA.original.displayName ? 1 : -1;
          },
          plugins: ['types', 'search', 'sort'],
        })

        .bind('select_node.jstree', (_e, data) => {
          const { href } = data.node.a_attr;
          if (href !== '#') {
            window.open(href);
          }
        });
    }

    function search() {
      const element = $(`#${elementId}`);
      element.jstree('search', _.trim(vm.filter));
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();
